import { render, staticRenderFns } from "./ApiConfig.vue?vue&type=template&id=7c810430&scoped=true"
import script from "./ApiConfig.vue?vue&type=script&lang=js"
export * from "./ApiConfig.vue?vue&type=script&lang=js"
import style0 from "./ApiConfig.vue?vue&type=style&index=0&id=7c810430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c810430",
  null
  
)

export default component.exports